let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6nq95")).then(() => parcelRequire('g3LKx'));